


























import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import { LineStyle, Color, LineKinds, PaintStyle, TextureKinds, TextStyle, TextAlignKinds } from "../../../../../../base/domain/drawing";
import { TextBoxDragHandles } from "../../../../../../base/components/dragging";
import { ObjectKeys } from "../../../../../domain/configuration";
import { RectangleCoordinatableObjectDrawerBase } from "./base";
import { ConfiguredInputEditor } from "./drawers";
import { TextPropertyEditableMixin } from "../../mixins";
import { ObjectUpdatesPromptableMixin } from "../trackers/mixins";

@Component({
  components: {
    ConfiguredInputEditor,
    TextBoxDragHandles,
  },
})
export default class InputRectangleCoordinatableObjectEditor extends Mixins(RectangleCoordinatableObjectDrawerBase, TextPropertyEditableMixin, ObjectUpdatesPromptableMixin) {
  @Prop({ default: false })
  readonly: boolean;

  @Prop({ type: Function, default: (v: string) => true })
  restriction: (v: string) => boolean;

  @Prop({ type: Function, default: (v: string) => true })
  validate: (v: string) => boolean;

  @Prop()
  configurationKey: ObjectKeys;

  @Prop({ default: () => new TextStyle(new Color("#ff0000"), TextAlignKinds.MiddleCenter, 8) })
  textStyle: TextStyle;

  @Prop({ default: () => new PaintStyle(new Color("#ffff00"), TextureKinds.Fill) })
  paintStyle: PaintStyle;

  @Prop({ default: () => new LineStyle(new Color("#ff0000"), LineKinds.Normal, 1) })
  borderStyle: LineStyle;

  editingText: string = "";

  mounted() {
    this.editingText = this.text;
  }

  @Watch("text")
  onTextUpdated(newValue: string, oldValue: string): void {
    this.editingText = newValue;
  }

  @Watch("editingText")
  onEditingTextUpdated(newValue: string, oldValue: string): void {
    if (this.text !== newValue) {
      if (!this.restriction(newValue)) {
        this.$nextTick(() => this.editingText = oldValue);  // 制約を満たしてなければ元に戻す.
      } else {
        this.text = newValue;
      }
    }
  }

  onMouseDowned(event: PointerEvent) {
    const currentPage = this.getCommonComponents().getOperators().getCurrentPage();
    if (this.isSelected) {
      return;
    }
    this.promptForObjectUpdates(event);
    this.$nextTick(() => {
      if (!event.ctrlKey) {
        currentPage.reselectObjects(this.editingSource);
      } else {
        currentPage.selectObjects(this.editingSource);
      }
    });
  }
}
